import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 15px;
`
export default Container
